import { createReducer, createActions } from 'reduxsauce'
import update from 'immutability-helper'

const { Types, Creators } = createActions(
  {
    request: ['fileKey', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'DOWNLOAD_FILE_',
  }
)

export interface DownloadFileState {
  loading: boolean
  errorMessage: string | null
  data: any | null
}

export interface DownloadFileRequestAction {
  fileKey: string
  onSuccess?: (data: any) => void
  onFailure?: () => void
}

interface SuccessAction {
  data: any
}

interface FailureAction {
  errorMessage: string
}

const INITIAL_STATE: DownloadFileState = {
  loading: false,
  errorMessage: null,
  data: null,
}

const request = (state: DownloadFileState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  })

const success = (state: DownloadFileState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  })

const failure = (state: DownloadFileState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  })

const softReset = (state: DownloadFileState) =>
  update(state, {
    loading: { $set: false },
  })

const reset = () => INITIAL_STATE

export const downloadFile = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
})

export const DownloadFileTypes = Types
export const DownloadFileActions = Creators
